import { SortableWidgetProps, Widget } from '@creditsights/styleguide-web';
import React, { forwardRef, ReactElement } from 'react';
import { RiskOverviewMetrics } from '../../../models/RiskProducts';
import ScoreCharts from '../../ScoreCharts';
import CircleBar from '../../ScoreCharts/CircleBar';
import ScoreLine from '../../ScoreCharts/ScoreLine';
import { creColorConfig, CreditRiskLevel } from './CreSummary.constants';
import { getPeriod, Trend } from './RiskSummary.logic';

interface CreSummaryWidgetProps extends SortableWidgetProps {
  riskOverviewMetrics: RiskOverviewMetrics;
}

const CreSummaryWidget = (
  { riskOverviewMetrics, ...sortableWidgetProps }: CreSummaryWidgetProps,
  ref
): ReactElement | null => {
  const { cre_1y: cre, cre_trend_1y: trend1year, cre_trend_6m: trend6months } = riskOverviewMetrics.cre;
  const { credit_risk_level: crl } = riskOverviewMetrics.cqs;
  const crePercentage = cre !== null ? Number((100 * cre).toFixed(2)) : null;
  const period = crePercentage !== null ? getPeriod(crePercentage) : null;
  return (
    <Widget headerTitle="Credit Risk Estimate" dataTestId="cre-summary-widget" ref={ref} {...sortableWidgetProps}>
      <ScoreCharts
        leftSide={
          crePercentage !== null && period !== null ? (
            <CircleBar value={crePercentage} color={creColorConfig[period]} label={`${crePercentage}%`} />
          ) : null
        }
        rightSide={
          trend1year || trend6months || crl ? (
            <>
              {trend6months && Trend.includes(trend6months) && (
                <ScoreLine title="Trend 6 Mo" steps={Trend} activeStep={trend6months} />
              )}
              {trend1year && Trend.includes(trend1year) && (
                <ScoreLine title="Trend 12 Mo" steps={Trend} activeStep={trend1year} />
              )}
              {crl && CreditRiskLevel.includes(crl) && (
                <ScoreLine title="Credit Risk Level" steps={CreditRiskLevel} activeStep={crl} />
              )}
            </>
          ) : null
        }
      />
    </Widget>
  );
};

export default forwardRef(CreSummaryWidget);
